import { EditRow, DeleteRow } from '../customRows';

export const equityCreditColumns = [
    { id: 'type', title: 'Type', sortable: true },
    { id: 'isin', title: 'ISIN', sortable: true },
    {
        id: 'bucket', title: 'Risk Bucket', sortable: true, type: 'number'
    }
];

export const isdaColumns = [
    { id: 'field', title: 'FO Curve Name', sortable: true },
    { id: 'mappedField', title: 'ISDA Mapping', sortable: true },
    {
        id: 'editRow',
        title: '',
        width: 50,
        filterable: false,
        sortable: false,
        renderCell: EditRow
    },
    {
        id: 'deleteRow',
        title: '',
        width: 50,
        filterable: false,
        sortable: false,
        renderCell: DeleteRow
    }
];


export const commodityColumns = [
    { id: 'field', title: 'Commodity', sortable: true },
    { id: 'mappedField', title: 'ISDA Commodity', sortable: true },
    {
        id: 'editRow',
        title: '',
        width: 50,
        filterable: false,
        sortable: false,
        renderCell: EditRow
    },
    {
        id: 'deleteRow',
        title: '',
        width: 50,
        filterable: false,
        sortable: false,
        renderCell: DeleteRow
    }
];

export const equityMappingColumns = [
    { id: 'field', title: 'SEDOL/CUSIP', sortable: true },
    { id: 'mappedField', title: 'ISIN', sortable: true },
    {
        id: 'editRow',
        title: '',
        width: 50,
        filterable: false,
        sortable: false,
        renderCell: EditRow
    },
    {
        id: 'deleteRow',
        title: '',
        width: 50,
        filterable: false,
        sortable: false,
        renderCell: DeleteRow
    }
];

export const standardProductClassColumns = [
    {
        id: 'field',
        title: 'Deal Type',
        sortable: true
    },
    {
        id: 'mappedField',
        title: 'Standard Product Class',
        sortable: true
    },
    {
        id: 'editRow',
        title: '',
        width: 50,
        filterable: false,
        sortable: false,
        renderCell: EditRow
    }
];

export const currencyMappingColumns = [
    {
        id: 'field',
        title: 'Onshore Currency',
        sortable: true
    },
    {
        id: 'mappedField',
        title: 'Offshore Currency',
        sortable: true
    },
    {
        id: 'editRow',
        title: '',
        width: 50,
        filterable: false,
        sortable: false,
        renderCell: EditRow
    },
    {
        id: 'deleteRow',
        title: '',
        width: 50,
        filterable: false,
        sortable: false,
        renderCell: DeleteRow
    }
];

export const standardProductClassDropdown = [
    'Rates', 'FX', 'Equity', 'Commodity', 'Credit'
];

export const initialGridSorting = [
    {
        gridId: 'isda',
        gridSort: [{ id: 'field', desc: false }]
    },
    {
        gridId: 'equity',
        gridSort: [{ id: 'sedol', desc: false }]
    },
    {
        gridId: 'commodity',
        gridSort: [{ id: 'field', desc: false }]
    },
    {
        gridId: 'productClass',
        gridSort: [{ id: 'field', desc: false }]
    }
];
